import { useQuery } from '@tanstack/react-query';

import Client from './client';

import type { UseQueryOptions } from '@tanstack/react-query';

type Response = Awaited<ReturnType<typeof Client.getLicensePlates>>;

const select = (response: Response) => {
  return response?.data?.data;
};

export const useLicensePlates = (
  options: Omit<UseQueryOptions<Response>, 'queryFn' | 'queryKey'> = {},
) => {
  const { data, ...query } = useQuery({
    ...options,
    queryKey: ['license-plate'],
    queryFn: () => Client.getLicensePlates(),
    refetchInterval: false,
    select,
  });

  return {
    licensePlates: data,
    ...query,
  };
};
